<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type half_int">
					<autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @selected="selectClass" results-display="code_name" placeholder="Item / Class Name or Code"> </autocomplete>
				</span>
				<span class="int_type_no_border mgr_5">
					<ItemClassSelectMulti v-model.trim="item_classes_string" />
				</span>
			</div>
			<div class="left_option">
				<em class="lt_text">Base Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="base_date"/></span>
				<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
				<font color="red"><b>Takes very long time.</b></font>
			</div>
		</div>
		<div>
			<table class="list_tbl sticky_list_tbl">
				<colgroup>
					<col style="width: 4%;" />
					<col style="width: 5%;" />
					<col style="width: 2%;" />
					<col style="width: 7%;" />
					<col style="width: 7%;" />
					<col />
					<col style="width:8%;" />
					<col style="width: 5%;" />
					<col style="width: 5%;" />
					<col style="width: 5%;" v-if="user.cost_view_yn == 'Y'" />
					<col style="width: 5%;" />
					<col style="width: 5.5%;" />
					<col style="width: 3.5%;" />
					<col style="width: 3.5%;" />
					<col style="width: 3.5%;" />
					<col style="width: 3.5%;" />
					<col style="width: 3.5%;" />
					<col style="width: 3.5%;" />
					<col style="width: 3.5%;" />
					<col style="width: 3.5%;" />
				</colgroup>
				<thead>
					<tr>
						<th>Item ID</th>
						<th>UPC</th>
						<th>Grp Order</th>
						<th>Grp Name</th>
						<th>{{ headers.class }} Code</th>
						<th>{{ headers.class }} Name</th>
						<th>Item Color</th>
						<th>On Board</th>
						<th>On Hand</th>
						<th v-if="user.cost_view_yn == 'Y'">Cost</th>
						<th>Fob</th>
						<th>L. Sh No</th>
						<th>L. Rcvd Date</th>
						<th>L. Rcvd Price</th>
						<th>Under 30</th>
						<th>Under 60</th>
						<th>Under 90</th>
						<th>Under 180</th>
						<th>Under 365</th>
						<th>Under 2 Year</th>
						<th>Over 2 Year</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in items" v-bind:key="item.item_id">
						<td>{{ item.item_id }}</td>
						<td>{{ item.barcode }}</td>
						<td class="al_right">{{ item.group_order_no }}</td>
						<td>{{ item.group_name }}</td>
						<td>{{ item.class_code }}</td>
						<td>{{ item.class_name }}</td>
						<td>{{ item.color_code }}</td>
						<td class="al_right">{{ item.on_board_quantity | commaSeparated }}</td>
						<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
						<td class="al_right" v-if="user.cost_view_yn == 'Y'">{{ item.cost | toCurrency }}</td>
						<td class="al_right">{{ item.fob | toCurrency }}</td>
						<td>
							<a href="javascript:void(0)" @click="gotoShipment(item.sh_no)"> {{ item.last_sh_dn }}</a>
						</td>
						<td>{{ item.last_received_date }}</td>
						<td class="al_right">{{ item.last_received_price | toCurrency }}</td>
						<td class="al_right">{{ item.under_30 | commaSeparated }}</td>
						<td class="al_right">{{ item.under_60 | commaSeparated }}</td>
						<td class="al_right">{{ item.under_90 | commaSeparated }}</td>
						<td class="al_right">{{ item.under_180 | commaSeparated }}</td>
						<td class="al_right">{{ item.under_365 | commaSeparated }}</td>
						<td class="al_right">{{ item.under_730 | commaSeparated }}</td>
						<td class="al_right">{{ item.over_730 | commaSeparated }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiSelectItemAgingList } from '@/api/report/report';
import { apiGetReportTemplate, exportFile, objectCopy, Report, reportMrtUrl } from '@/api/util';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { today } from '@/utils/date';
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';

export default {
	props: ['headers'],
	data: function() {
		return {
			root: '',

			backUri: '/',
			paging_yn: 'Y',
			page_size: 28,
			page_no: 1,
			list_count: 0,

			base_date: today(),

			items: [],
			excelItems: [],
			saveParam: {},

			item_classes_string: '',
			item_classes: [],

			keyword: null,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		ItemClassSelectMulti,
	},
	methods: {
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&include_closed_yn=N&keyword=' + input;
			return url;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += ', ' + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
			//this.itemClass = c.selectedObject.code;
			//this.search();

			//console.log(c.selectedObject.code);
		},

		gotoShipment(sh_no) {
			let routeData = this.$router.resolve({ name: 'shipmentDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, sh_no: sh_no } });
			window.open(routeData.href, 'herp_shipmentDetail');
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectData(pageNo);
		},
		async selectData(pageNo) {
			if (this.item_classes_string) this.item_classes = this.item_classes_string.split(',');
			else this.item_classes = [];

			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			const param = {
				base_date: this.base_date,
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				item_classes: this.item_classes,
			};
			this.saveParam = objectCopy({
				base_date: this.base_date,
				paging_yn: 'N',

				item_classes: this.item_classes,
			});
			const { data } = await apiSelectItemAgingList(param);
			this.items = data.itemAgingList;
			this.list_count = data.list_count; //data.list_count;
			//console.log(this.items);
			//this.root = data.value;
			//console.log(data.value);
			//console.log(this.root.total_post_check_amount);

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
		},
		async index() {},
		async excel() {
			const { data } = await apiSelectItemAgingList(this.saveParam);
			data.headersClass = this.headers.class;
			data.cost_view_yn = this.user.cost_view_yn;
			const reportTemplate = await apiGetReportTemplate('ItemAging', reportMrtUrl('ItemAging'));
			const report = new Report(reportTemplate, data, 'ItemAging');
			exportFile(report, 'excel');
		},
		reset() {},
		lineNumber() {
			this.itemIndex += 1;
			return this.itemIndex;
		},
	},

	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_item_aging');
		this.$store.commit('setSubTitle', 'Report -> Item Aging');
		this.index();
	},
};
</script>

<style scoped></style>
